import React, { useState } from 'react'
import PageHead from '../components/PageHead'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { Axios, baseURL } from '../utils/Axios'
import Container from '../ui/comp/Container'
import Input from '../ui/forms/Input'
import Button from '../ui/comp/Button'
import axios from 'axios'
import toast from 'react-hot-toast'
import { displayImage } from '../utils/config'
import { FiEdit } from 'react-icons/fi'
import { CgTrash } from 'react-icons/cg'

function OurShop() {

    const queryClient = useQueryClient()

    const [formData, setFormData] = useState({
        name: "", image: "", address: "", google_address_link: "",
        telephone: "", email: "", time_avalable1: "", time_avalable2: ""
    })

    const [isOpen, setIsOpen] = useState(false)

    const { data } = useQuery({
        queryKey: ["shop"],
        queryFn: async () => {
            const res = await Axios.get('/shop')
            return res.data;
        }
    })


    // inputChane

    const inputChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value })
    }

    // uploading file

    const fileChangeBanner = async (files) => {
        if (files?.length) {
            const formData1 = new FormData();

            Object.keys(files).forEach(key => {
                formData1.append('file', files[key])
            })
            try {
                const res = await axios.post(`${baseURL}/upload`, formData1)
                const data = await res.data;
                setFormData({ ...formData, image: data[0] })
                console.log(formData);
                toast.success('File Uploaded')
            } catch (error) {
                toast.error(error?.response?.data || "Error while uploading file")
            }
        }
    }

    // Delete
    const { mutate: deleteMutate } = useMutation({
        mutationFn: async (id) => {
            return Axios.delete('/shop?id=' + id)
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["shop"] })
        }
        ,
        onError: (error) => {
            toast.error(error?.response?.data || error.message)
        },
    })

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete")) {
            deleteMutate(id)
        }
    }


    // Send Data

    const { mutate, isPending } = useMutation({
        mutationFn: async (formData) => {
            return Axios.post('/shop', formData)
        },
        onError: (error) => {
            toast.error(error?.response?.data || error.message)
        },
        onSuccess: () => {
            setIsOpen(false)
            setFormData({
                name: "", image: "", address: "", google_address_link: "",
                telephone: "", email: "", time_avalable1: "", time_avalable2: ""
            })
            toast.success("Successfully")
            queryClient.invalidateQueries({ queryKey: ["shop"] })
        }
    })

    const sendData = () => {
        mutate(formData)
    }


    return (
        <div className='w-full relative'>
            <PageHead title={"Shops Locations"} />

            <div className="mt-7">
                <Button onClick={() => setIsOpen(!isOpen)}>Add Location</Button>
            </div>

            {isOpen && (
                <div className="mt-9">
                    <Container>
                        <div className="w-full relative mt-7">
                            <Container>
                                <div className="space-y-8">
                                    {/* Row 1 */}
                                    <div className="flex w-full items-center gap-5">
                                        {/* Image */}
                                        <div className="w-full space-y-3">
                                            <p className="text-sm">Image</p>
                                            <div>
                                                <input type='file' onChange={(e) => fileChangeBanner(e.target.files)} />
                                                <div className="mt-2">
                                                    <img src={displayImage(formData?.image)} alt="" className="w-24 p-1 border" />
                                                </div>
                                            </div>
                                        </div>
                                        {/* Location Name */}
                                        <div className="w-full space-y-3">
                                            <p className="text-sm">Location Name</p>
                                            <div>
                                                <Input value={formData?.name} id="name" onChange={inputChange} />
                                            </div>
                                        </div>

                                        {/* Location Address */}
                                        <div className="w-full space-y-3">
                                            <p className="text-sm">Location Address</p>
                                            <div>
                                                <Input value={formData?.address} id="address" onChange={inputChange} />
                                            </div>
                                        </div>

                                        {/* Google Map Link */}
                                        <div className="w-full space-y-3">
                                            <p className="text-sm">Google Map Link</p>
                                            <div>
                                                <Input value={formData?.google_address_link} id="google_address_link" onChange={inputChange} />
                                            </div>
                                        </div>
                                    </div>
                                    {/* Row 2 */}
                                    <div className="flex w-full items-center gap-5">
                                        {/* Location Telephone */}
                                        <div className="w-full space-y-3">
                                            <p className="text-sm">Location Telephone</p>
                                            <div>
                                                <Input value={formData?.telephone} id="telephone" onChange={inputChange} />
                                            </div>
                                        </div>
                                        {/* Location Email */}
                                        <div className="w-full space-y-3">
                                            <p className="text-sm">Location Email</p>
                                            <div>
                                                <Input value={formData?.email} id="email" onChange={inputChange} />
                                            </div>
                                        </div>

                                        {/* Time Available 1 */}
                                        <div className="w-full space-y-3">
                                            <p className="text-sm">Time Available 1</p>
                                            <div>
                                                <Input placeholder={formData?.time_avalable1} id="time_avalable1" onChange={inputChange} />
                                            </div>
                                        </div>

                                        {/* Time Available 2 */}
                                        <div className="w-full space-y-3">
                                            <p className="text-sm">Time Available 2 (optional)</p>
                                            <div>
                                                <Input placeholder={formData?.time_avalable2} id="time_avalable2" onChange={inputChange} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex gap-3">
                                        <Button
                                            loading={isPending}
                                            onClick={sendData}
                                        >{formData?.id ? "Update" : "Add Location"}</Button>
                                        <Button
                                            onClick={() => {
                                                setIsOpen(false)
                                                setFormData({ firstname: "", lastname: "", email: "", password: "", display_picture: "", role: "" })
                                            }}
                                            color="red"
                                        >Cancel
                                        </Button>
                                    </div>
                                </div>
                            </Container>
                        </div >
                    </Container>
                </div>
            )}







            {/* Stores Data */}


            <div className="mt-8">
                {data && data?.length > 0 && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
                        {data?.map((shop, i) => (
                            <div className="w-full relative">
                                <div className="bg-white p-4 rounded-md flex gap-3">
                                    {/* image */}
                                    <div className='w-40 rounded overflow-hidden'>
                                        <img src={displayImage(shop?.image)} alt="" />
                                    </div>

                                    {/* Content */}
                                    <div className="">
                                        <h3 className="text-lg font-medium">{shop?.name}</h3>
                                        <p className="text-sm text-gray-500">{shop?.address}</p>
                                        <div className="flex items-center gap-1 text-gray-500 mt-2">
                                            <button
                                                onClick={() => {
                                                    setIsOpen(true)
                                                    setFormData(shop)
                                                }}
                                                className='text-primary' title='Edit'
                                            >
                                                <FiEdit size={18} />
                                            </button>
                                            <button onClick={() => handleDelete(shop?.id)} title='Delete' className='text-red-400'><CgTrash size={18} /></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

        </div>
    )
}

export default OurShop